// Home.js
import React from 'react';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import './home.css';
import Skills from './Skills';
import Education from './Education';
import Projects from './Projects';
import Contact from './Contact';
import Navbar from './Navbar';
import About from './About';
import ProjectCard from './ProjectCard';
import Social from './Social';
const ComponentWithAnimation = ({ children }) => {
  const [ref, inView] = useInView({
    threshold: 0.25, // Trigger animation when 50% of the component is in the viewport
  });

  const animationProps = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(-10px)' : 'translateY(30px)',
  });

  return (
    <animated.div ref={ref} style={animationProps}>
      {children}
    </animated.div>
  );
};

const Home = () => {
  const projects = [
    {
      id: '01',
      title: 'AI Research Assistant',
      image: 'ai-research.png',
      description: 'Agentic assistant processes PDFs, YouTube lectures, and web articles to answer queries with source citations using LangChain and Groq LLM',
      github: 'https://github.com/rohit0796/Reasearch-Asisstant-AI',
      tech: ["LangChain", "Groq LLM", "HuggingFace", "FAISS", "FastAPI", "React.js"],
      type: 'ai'  // Added type for GenAI project
    },
    { 
      id: '02', 
      title: 'TravelBuddy', 
      image: 'travel-Buddy.png', 
      description: 'Cross-platform travel app for finding partners, trip planning, expense management with real-time chat', 
      github: 'https://github.com/rohit0796/travelBuddy-Backend', 
      link: 'https://play.google.com/store/apps/details?id=com.TravelBuddy', 
      tech: ["React Native", "Express.js", "MongoDB", "Socket.io"],
      type: 'mobile'  // Added type for mobile app
    },
    { 
      id: '03', 
      title: 'CollabFlow', 
      image: 'collabflow desk.png', 
      description: 'Collaborative project management tool with task assignment, progress tracking, discussion forums, audio/video calling, and intuitive dashboard for seamless team collaboration and productivity', 
      github: 'https://github.com/rohit0796/CollabFlow', 
      link: 'https://collabflow-82014.firebaseapp.com/', 
      tech: ["React.js", "Tailwind css", "Firebase"],
      type: 'web'  // Added type for web app
    },
    // You can add more projects with their respective types
  ];
  return (
    <div className="home">
      <Navbar />

      <ComponentWithAnimation>
        <section id="about">
          <About />
          {/* <StarsCanvas/> */}
        </section>
      </ComponentWithAnimation>
      <section id="projects">
        <ComponentWithAnimation>
          <h2 className="section-title">Some Things I've Built</h2>
          {
            projects.map((project, ind) =>
            (
              <ComponentWithAnimation>
                <ProjectCard project={project} index={ind} />
              </ComponentWithAnimation>
            )
            )
          }
        </ComponentWithAnimation>
          <Projects />
      </section>
      <ComponentWithAnimation>
        <section id="skills">
          <Skills />
        </section>
      </ComponentWithAnimation>
      <ComponentWithAnimation>
        <section id="education">
          <Education />
        </section>
      </ComponentWithAnimation>
      <ComponentWithAnimation>
        <section id="contact">
          <Contact />
        </section>
      </ComponentWithAnimation>
      <Social />
    </div>
  );
};

export default Home;
